import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess103002Status: 'idle',
    startProcess103002Error: undefined as any,
    loadUserParamsProcess103002Status: 'idle',
    loadUserParamsProcess103002Error: undefined as any,

    process103002List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess103002 = createAsyncThunk('process103002Slice/startProcess103002', async ({ process103002 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess103002/`,
        prepareData(process103002),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess103002Status } = getState().process103002Slice
        return startProcess103002Status !== 'pending'
    }
})

export const loadUserParamsProcess103002 = createAsyncThunk('process103002Slice/loadUserParamsProcess103002', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess103002/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess103002Status } = getState().process103002Slice
        return loadUserParamsProcess103002Status !== 'pending'
    }
})

const Process103002Slice = createSlice({
    name: 'process103002Slice',
    initialState,
    reducers: {
        resetstartProcess103002: (state) => {
            state.job = undefined
            state.startProcess103002Error = undefined
        },
        resetstartProcess103002Error: (state) => {
            state.startProcess103002Error = undefined
        },
        resetloadUserParamsProcess103002: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess103002Error = undefined
        },
        resetloadUserParamsProcess103002Error: (state) => {
            state.loadUserParamsProcess103002Error = undefined
        },
        removeFromProcess103002ListById: (state, action) => {
            state.process103002List = state.process103002List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess103002ListByIds: (state, action) => {
            state.process103002List = state.process103002List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process103002List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess103002Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process103002List = []
            state.startProcess103002Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess103002.pending, (state) => {
            state.startProcess103002Status = 'pending'
            state.startProcess103002Error = undefined
        })
        builder.addCase(startProcess103002.fulfilled, (state, action) => {
            state.startProcess103002Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess103002.rejected, (state, action) => {
            state.startProcess103002Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess103002Error = action.error.message
            } else {
                state.startProcess103002Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess103002.pending, (state) => {
            state.loadUserParamsProcess103002Status = 'pending'
            state.loadUserParamsProcess103002Error = undefined
        })
        builder.addCase(loadUserParamsProcess103002.fulfilled, (state, action) => {
            state.loadUserParamsProcess103002Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess103002.rejected, (state, action) => {
            state.loadUserParamsProcess103002Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess103002Error = action.error.message
            } else {
                state.loadUserParamsProcess103002Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess103002,
    resetstartProcess103002Error,
    resetloadUserParamsProcess103002,
    resetloadUserParamsProcess103002Error,
    removeFromProcess103002ListById,
    removeFromProcess103002ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process103002Slice.actions
export default Process103002Slice.reducer
